const presonusData = {
    "segmentDev": "wFqfXRZ1LY0CjeX0ndYt6MU9tL2EunA3",
    "segmentProd": "CpcL7xGbiJCzvIx0OzI91FVqsBSENOH9"
};

export default presonusData;